/* Savage Gear — ficha de producto: galería, variantes y cantidad.
   El formulario funciona sin JS; esto solo evita recargas. */

(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  function galeria() {
    const fotos = $$('.sg-pdp__foto');
    const minis = $$('[data-sg-mini]');
    if (fotos.length < 2) return;
    minis.forEach((b) =>
      b.addEventListener('click', () => {
        const i = parseInt(b.dataset.sgMini, 10);
        // La imagen cambia directo, sin crossfade: quien compara sabores
        // toca esto muchas veces y cualquier transición estorba.
        fotos.forEach((f, k) => (f.hidden = k !== i));
        minis.forEach((m, k) => m.setAttribute('aria-current', String(k === i)));
      })
    );
  }

  function cantidad() {
    const campo = $('[data-sg-cantidad]');
    if (!campo) return;
    $('[data-sg-menos]')?.addEventListener('click', () => {
      campo.value = Math.max(1, parseInt(campo.value, 10) - 1);
    });
    $('[data-sg-mas]')?.addEventListener('click', () => {
      campo.value = parseInt(campo.value, 10) + 1;
    });
  }

  function variantes() {
    const form = $('[data-sg-add-pdp]');
    if (!form || !window.SG_VARIANTES) return;
    const campo = $('[data-sg-variante]');

    function elegidas() {
      return $$('[data-sg-opcion]:checked').map((i) => i.value);
    }

    function actualizar() {
      const sel = elegidas();
      const v = window.SG_VARIANTES.find((x) =>
        x.options.every((o, i) => o === sel[i])
      );
      const boton = $('.sg-pdp__add');
      if (!v) {
        boton.disabled = true;
        return;
      }
      campo.value = v.id;
      boton.disabled = !v.available;
      const precio = $('[data-sg-precio]');
      if (precio && v.price_formatted) precio.textContent = v.price_formatted;
      const porcion = $('[data-sg-porcion]');
      if (porcion && v.por_porcion) {
        porcion.innerHTML = `<strong>${v.por_porcion} por porción</strong> · ${v.porciones} porciones por envase`;
      }
      // Cambiar la foto al cambiar de sabor. Sin esto el cliente elige
      // "Chocolate" y sigue viendo el envase de vainilla.
      if (typeof v.media === 'number' && v.media >= 0) {
        const fotos = $$('.sg-pdp__foto');
        if (fotos[v.media]) {
          fotos.forEach((f, k) => (f.hidden = k !== v.media));
          $$('[data-sg-mini]').forEach((b) =>
            b.setAttribute('aria-current', String(Number(b.dataset.sgMini) === v.media))
          );
        }
      }

      // La URL refleja la variante para que se pueda compartir el enlace
      const u = new URL(location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u);
    }

    $$('[data-sg-opcion]').forEach((i) => i.addEventListener('change', actualizar));
  }

  function agregar() {
    const form = $('[data-sg-add-pdp]');
    if (!form) return;
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const boton = $('.sg-pdp__add');
      if (boton.dataset.estado !== 'idle' || boton.disabled) return;
      boton.dataset.estado = 'cargando';
      try {
        const r = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: $('[data-sg-variante]').value,
              quantity: parseInt($('[data-sg-cantidad]').value, 10) || 1,
            }],
          }),
        });
        if (!r.ok) throw new Error();
        boton.dataset.estado = 'listo';
        document.dispatchEvent(new CustomEvent('sg:carrito-actualizado'));
        $('[data-sg-cart-open]')?.click();
        setTimeout(() => (boton.dataset.estado = 'idle'), 1800);
      } catch {
        boton.dataset.estado = 'idle';
        form.removeAttribute('data-sg-add-pdp');
        form.submit();
      }
    });
  }

  function init() { galeria(); cantidad(); variantes(); agregar(); }
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
